import React from 'react';
import { Link } from 'react-router-dom';

export const Terms: React.FC = () => {
  return (
    <div className="auth-shell">
      <div className="auth-card" style={{ maxWidth: '640px' }}>
        <h1 className="auth-title">Terms and Conditions</h1>
        <p className="helper-text" style={{ marginBottom: '1.5rem' }}>
          Last updated: February 2025
        </p>

        <div style={{ textAlign: 'left' }}>
          <h2 style={{ fontSize: '1.1rem', marginBottom: '0.5rem' }}>Nature of This Service</h2>
          <p style={{ marginBottom: '1rem', lineHeight: 1.6 }}>
            Reading Queue is a personal side project. It is not a commercial product and is not
            backed by any company or organization. The service is provided on a best-effort basis
            and may be modified, suspended, or discontinued at any time without notice.
          </p>

          <h2 style={{ fontSize: '1.1rem', marginBottom: '0.5rem' }}>Disclaimer of Warranties</h2>
          <p style={{ marginBottom: '1rem', lineHeight: 1.6 }}>
            THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND,
            EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE IMPLIED WARRANTIES OF
            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, AND NON-INFRINGEMENT.
          </p>
          <p style={{ marginBottom: '1rem', lineHeight: 1.6 }}>
            No warranty is made that the service will be uninterrupted, timely, secure, or
            error-free. No warranty is made regarding the accuracy or reliability of any
            information obtained through the service. No warranty is made that defects will be
            corrected or that the service is free of viruses or other harmful components.
          </p>

          <h2 style={{ fontSize: '1.1rem', marginBottom: '0.5rem' }}>Limitation of Liability</h2>
          <p style={{ marginBottom: '1rem', lineHeight: 1.6 }}>
            TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT SHALL THE SERVICE
            OPERATOR BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE
            DAMAGES, OR ANY LOSS OF PROFITS OR REVENUES, WHETHER INCURRED DIRECTLY OR INDIRECTLY,
            OR ANY LOSS OF DATA, USE, GOODWILL, OR OTHER INTANGIBLE LOSSES, RESULTING FROM YOUR
            ACCESS TO OR USE OF OR INABILITY TO ACCESS OR USE THE SERVICE.
          </p>

          <h2 style={{ fontSize: '1.1rem', marginBottom: '0.5rem' }}>Your Data</h2>
          <p style={{ marginBottom: '1rem', lineHeight: 1.6 }}>
            Your data will not be sold to third parties. Your data will not be shared with third
            parties for marketing or advertising purposes. The service may use third-party
            infrastructure providers (such as cloud hosting) to operate, but these providers do
            not have independent rights to your data.
          </p>
          <p style={{ marginBottom: '1rem', lineHeight: 1.6 }}>
            You are responsible for maintaining backups of any data you consider important.
            The service operator is not responsible for any loss of data.
          </p>

          <h2 style={{ fontSize: '1.1rem', marginBottom: '0.5rem' }}>Use at Your Own Risk</h2>
          <p style={{ marginBottom: '1rem', lineHeight: 1.6 }}>
            You use this service entirely at your own risk. By using this service, you acknowledge
            that you understand and accept these terms.
          </p>

          <h2 style={{ fontSize: '1.1rem', marginBottom: '0.5rem' }}>Changes to These Terms</h2>
          <p style={{ marginBottom: '1.5rem', lineHeight: 1.6 }}>
            These terms may be updated at any time. Continued use of the service after changes
            constitutes acceptance of the new terms.
          </p>
        </div>

        <div className="helper-text" style={{ marginTop: '1rem' }}>
          <Link to="/signup">Back to sign up</Link> · <Link to="/login">Log in</Link>
        </div>
      </div>
    </div>
  );
};

export default Terms;
